import { DefaultActions, Separator, Showing, Total, Search, Wrapper } from '@/components/Grid/components/header/Heading';
import { DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { useValidatorStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'

function ValidatorGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    events: useEvents(),
  })

  return <DefaultGrid filters={null}
    heading={<Wrapper>
      <Search />
      <Separator />
      <Total />
      <Showing />
      <Separator />
      <DefaultActions />
    </Wrapper>}
  />
}

export default function ValidatorGridLayout() {
  return <GridProvider store={useValidatorStore()}>
    <ValidatorGrid />
  </GridProvider>
}
